import React, { useState, useEffect } from 'react';
import apiClient from 'ps-components/lib/apiClient';
import { string, func, bool } from 'prop-types';

import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import useDebounce from '../../lib/useDebounce';
import SmartOption from './SmartOption';

SmartSearchOptions.propTypes = {
  clearInput: func,
  searchText: string,
  showOptions: bool,
  showSlideout: func,
  subsite: string
};

export default function SmartSearchOptions(props) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState('');

  const invokeDebounced = useDebounce(getActions, 500);
  useEffect(invokeDebounced, [props.searchText]);

  useEffect(() => {
    if (!props.searchText) {
      setLoaded(false);
    }
  }, [props.searchText]);

  function getActions() {
    if (props.searchText) {
      setLoading(true);
      setError('');

      apiClient
        .apiGet('/api/smart-search/search/getActions', {
          params: {
            search: props.searchText
          }
        })
        .then(result => {
          if (result.data.success) {
            setOptions(result.data.data.listOfActions);
          }
          setLoading(false);
          setLoaded(true);
        })
        .catch(error => {
          setError(error.message);
          setLoading(false);
          setLoaded(true);
        });
    }
  }

  if (!props.searchText || !props.showOptions || !loaded) {
    return null;
  }

  function getSmartOptions() {
    return options.map((option, index) => (
      <SmartOption
        key={`${option.action}-${option.category}-${index}`}
        action={option}
        subsite={props.subsite}
        showSlideout={props.showSlideout}
      />
    ));
  }

  return (
    <div className="smart-search__options">
      {loading ? (
        <InPlaceIndicator />
      ) : error ? (
        <div className="smart-search__error">{`Error searching: ${error}`}</div>
      ) : options.length === 0 ? (
        <div className="smart-search__error">{'No suggestions found'}</div>
      ) : (
        getSmartOptions()
      )}
    </div>
  );
}
